import React from 'react';
import { CopilotPanel, CopilotTrigger } from 'src/components/copilot';
import { useFeatureFlags } from 'src/context/FeatureFlagsContext';
import { AstraDesktopPanel } from './AstraDesktopPanel';
import { AstraDesktopTrigger } from './AstraDesktopTrigger';

interface AstraSurfaceSwitchProps {
  readonly isAuthenticated: boolean;
}

/**
 * Picks the Astra surface (launcher + panel) for the desktop shell by stage
 * flag: the Stencil pair (shared `AgentChatPanel`, `AIButton` launcher) when
 * `enableDesktopAstra` is on, the legacy Cloudscape copilot pair otherwise.
 * Both read the same `AstraProvider`, so flipping the flag changes the
 * chrome, never the conversation.
 *
 * Launcher and panel switch together so a Stencil panel is never opened from
 * the Cloudscape launcher or vice versa.
 *
 * Reads the flag through the context (unlike the mobile shell) because the
 * desktop tree mounts `FeatureFlagsProvider` at the root, which also honours
 * the non-prod dev-panel overrides.
 *
 * This is the one Astra file that touches `src/components/copilot/`. Once the
 * Stencil surface is on everywhere, drop the legacy branch here and delete
 * that folder.
 */
export function AstraSurfaceSwitch({
  isAuthenticated,
}: AstraSurfaceSwitchProps): React.JSX.Element {
  const { enableDesktopAstra } = useFeatureFlags();
  if (enableDesktopAstra) {
    return (
      <>
        <AstraDesktopTrigger isAuthenticated={isAuthenticated} />
        <AstraDesktopPanel />
      </>
    );
  }
  return (
    <>
      <CopilotTrigger isAuthenticated={isAuthenticated} />
      <CopilotPanel />
    </>
  );
}
